<template>
  <div class="">

    <div class="filter-box">
      <div class="filter-header">
        Search for clients
      </div>

      <div class="filter-body relative mt-1">
        <input type="text"
          class="border-b border-gray-500 focus:border-gray-600 outline-none pb-1 w-full"
          v-model="query"
          style="padding-left:25px;"
          v-on:keyup.enter="queryChanged($event.target.value)" />

        <div style="position: absolute;top:10px;left:8px;">
          <img src="https://cdn4.iconfinder.com/data/icons/small-n-flat/24/search-256.png" class="w-4" />
        </div>
      </div>
    </div>

    <div class="filter-box mt-4">
      <div class="filter-header">
        Client type
      </div>

      <div class="filter-body flex items-center">
        <input type="radio" name="input-client-type" v-model="clientType" v-on:change="clientTypeChanged" value="all" id="input-client-type-all" />
        <label for="input-client-type-all" class="filter-label mr-4">Any</label>

        <input type="radio" name="input-client-type" v-model="clientType" v-on:change="clientTypeChanged" value="active" id="input-client-type-active" />
        <label for="input-client-type-active" class="filter-label mr-4">Active</label>

        <input type="radio" name="input-client-type" v-model="clientType" v-on:change="clientTypeChanged" value="settled" id="input-client-type-settled" />
        <label for="input-client-type-settled" class="filter-label">Settled</label>       
      </div>
      <div class="filter-body flex items-center">
        <input type="radio" name="input-client-type" v-model="clientType" v-on:change="clientTypeChanged" value="pending" id="input-client-type-pending" />
        <label for="input-client-type-pending" class="filter-label">Pending</label>
      </div>
    </div>

    <div class="filter-box mt-4">
      <div class="filter-header">
        Status
      </div>

      <div class="filter-body">
        <div class="flex items-center">
          <input type="radio" name="input-status" v-model="status" v-on:change="statusChanged" value="all" id="input-status-all" />
          <label for="input-status-all" class="filter-label">Any</label>
        </div>

        <div class="flex items-center">
          <input type="radio" name="input-status" v-model="status" v-on:change="statusChanged" value="0" id="input-status-not-sent" />
          <label for="input-status-not-sent" class="filter-label">Not Sent</label>
        </div>

        <div class="flex items-center">
          <input type="radio" name="input-status" v-model="status" v-on:change="statusChanged" value="1" id="input-status-sent" />
          <label for="input-status-sent" class="filter-label">Sent</label>
        </div>

        <div class="flex items-center">
          <input type="radio" name="input-status" v-model="status" v-on:change="statusChanged" value="2" id="input-status-received" />
          <label for="input-status-received" class="filter-label">Received</label>
        </div>

        <div class="flex items-center">
          <input type="radio" name="input-status" v-model="status" v-on:change="statusChanged" value="3" id="input-status-completed" />
          <label for="input-status-completed" class="filter-label">Completed by broker</label>
        </div>
      </div>
    </div>



    <div class="filter-box mt-4">
      <div class="filter-header">
        Access
      </div>

      <div class="filter-body flex items-center mt-1">
        <input type="radio" name="input-access" v-model="access" v-on:change="accessChanged" value="all" id="input-access-all" />
        <label for="input-access-all" class="filter-label mr-4">Any</label>

        <input type="radio" name="input-access" v-model="access" v-on:change="accessChanged" value="enabled" id="input-access-not-enabled" />
        <label for="input-access-not-enabled" class="filter-label mr-4">Enabled</label>

        <input type="radio" name="input-access" v-model="access" v-on:change="accessChanged" value="disabled" id="input-access-disabled" />
        <label for="input-access-disabled" class="filter-label">Disabled</label>
      </div>
    </div>

    <div class="filter-box mt-4">
      <div class="filter-header">
        Primary reason for credit
      </div>

      <div class="filter-body">
        <select v-model="primaryReason" class="border border-gray-500 w-full" v-on:change="primaryReasonChanged">
          <option value="all">Any</option>
          <option value="0">Buy Home</option>
          <option value="1">Debt Consolidate</option>
          <option value="2">Refinance</option>
          <option value="3">Buy Investment Property</option>
          <option value="4">Renovation / Cash Out</option>
          <option value="5">Buy Land</option>
          <option value="7">Land &amp; Construction</option>
          <option value="6">Other</option>
        </select>
      </div>
    </div>

    <div class="filter-box mt-4">
      <div class="filter-header">
        First home buyer?
      </div>

      <div class="filter-body flex items-center mt-1">
        <input type="radio" name="input-first-home-buyer" v-model="firstHomeBuyer" v-on:change="firstHomeBuyerChanged" value="all" id="input-first-home-buyer-all" />
        <label for="input-first-home-buyer-all" class="filter-label mr-4">Any</label>

        <input type="radio" name="input-first-home-buyer" v-model="firstHomeBuyer" v-on:change="firstHomeBuyerChanged" value="1" id="input-first-home-buyer-not-enabled" />
        <label for="input-first-home-buyer-not-enabled" class="filter-label mr-4">Yes</label>

        <input type="radio" name="input-first-home-buyer" v-model="firstHomeBuyer" v-on:change="firstHomeBuyerChanged" value="0" id="input-first-home-buyer-disabled" />
        <label for="input-first-home-buyer-disabled" class="filter-label">No</label>
      </div>
    </div>

    <div class="filter-box mt-4">
      <div class="filter-header">
        Client source
      </div>

      <div class="filter-body">
        <select v-model="clientSource" class="border border-gray-500 w-full" v-on:change="clientSourceChanged">
          <option value="all">Any</option>
          <option value="accountant">Accountant</option>
          <option value="client">Client</option>
          <option value="family">Family</option>
          <option value="financial-planner">Financial planner</option>
          <option value="friend">From a friend</option>       
          <option value="property-developer">Property developer</option>   
          <option value="real-estate-agent">Real estate agent</option>
          <option value="self">Self-sourced</option>          
          <option value="solicitor">Solicitor</option>
          <option value="other">Other</option>
        </select>
      </div>
    </div>



    <!--<div class="float-left text-sm" style="margin:10px 8px 0 30px;">
      <a href="#"
         class="no-underline text-xs uppercase  text-gray-600 hover:underline"
         @click.prevent="reset()">Reset</a>
    </div> -->
  </div>
</template>

<script>
  import { EventBus } from '@/shared/event-bus'

  export default {

    components : {

    },

    // props : {
    //   params : {
    //     type    : Object,
    //     required: false
    //   }
    // },

    watch: {
      '$route' : {
        immediate: true,
        handler  : function(to, from) {
          this.setFilterValues(to.params)
        }
      }
    },

    data() {
      return {
        query         : null,
        clientType    : 'active',
        status        : 'all',
        access        : 'all',
        primaryReason : 'all',
        firstHomeBuyer: 'all',
        clientSource: 'all'
      }
    },

    methods : {

      setFilterValues(params) {
        this.query          = params.query == null || params.query == this.$store.state.emptyQueryIndicator ? null : params.query
        this.clientType     = params.clientType == null ? 'active' : params.clientType
        this.status         = params.status == null ? 'all' : params.status
        this.access         = params.access == null ? 'all' : params.access
        this.primaryReason  = params.primaryReason == null ? 'all' : params.primaryReason
        this.firstHomeBuyer = params.firstHomeBuyer == null ? 'all' : params.firstHomeBuyer
        this.clientSource = params.clientSource == null ? 'all' : params.clientSource
      },

      clientTypeChanged() {
        EventBus.$emit('param-changed', {
          key  : 'clientType',
          value: this.clientType
        })
      },

      statusChanged() {
        EventBus.$emit('param-changed', {
          key  : 'status',
          value: this.status
        })
      },

      accessChanged() {
        EventBus.$emit('param-changed', {
          key  : 'access',
          value: this.access
        })
      },

      primaryReasonChanged() {
        EventBus.$emit('param-changed', {
          key  : 'primaryReason',
          value: this.primaryReason
        })
      },

      firstHomeBuyerChanged() {
        EventBus.$emit('param-changed', {
          key  : 'firstHomeBuyer',
          value: this.firstHomeBuyer
        })
      },

      clientSourceChanged() {
        EventBus.$emit('param-changed', {
          key  : 'clientSource',
          value: this.clientSource
        })
      },

      queryChanged(value) {
        EventBus.$emit('param-changed', {
          key  : 'query',
          value: value != null && value.length > 0 ? value : this.$store.state.emptyQueryIndicator
        })
      },

    //   reset() {
    //     EventBus.$emit('reset-params')
    //   },
    }
  }
</script>

<style scoped>
  .filter-box {
    @apply border border-gray-400 rounded bg-gray-100;
  }

  .filter-box:hover {
    @apply border-gray-600;
  }

  .filter-header {
    @apply text-sm text-gray-800 px-2 py-1;
  }

  .filter-body {
    @apply bg-white p-2;
    border-radius:0 0 5px 5px;
  }

  .filter-label {
    @apply ml-2;
  }
</style>